export const translations = {
  de: {
    nav: {
      home: "Startseite",
      about: "Über uns",
      services: "Leistungen",
      gallery: "Galerie",
      contact: "Kontakt",
      cta: "Anfrage senden",
    },
    home: {
      eyebrow: "Pizza · Catering · Streetfood",
      hero_slogan: "„Taste the Moment\u201C",
      hero_title_a: "Genuss, der",
      hero_title_b: "Menschen verbindet.",
      hero_sub:
        "Authentische Pizza mit italienischen Wurzeln, modern interpretiert für Hochzeiten, Firmenfeiern und besondere Anlässe.",
      cta_primary: "Jetzt Anfrage senden",
      cta_secondary: "Unsere Leistungen",
      intro_eyebrow: "Wer wir sind",
      intro_title: "Die Menschen hinter Tæste.",
      intro_body:
        "Für uns bedeutet Genuss, bewusst Zeit miteinander zu verbringen, besondere Momente zu schaffen und gutes Essen mit Atmosphäre, Qualität und Emotion zu verbinden. Wir möchten nicht einfach Speisen servieren, wir schaffen Erlebnisse.",
      intro_link: "Lerne Annabell & Edgar kennen",
      services_eyebrow: "Unsere Leistungen",
      services_title: "Pizza im Mittelpunkt.",
      services_lead: "Wir machen hauptsächlich Pizza, handgemacht, mit langer Teigreifezeit und sorgfältig ausgewählten Zutaten. Auf Wunsch begleiten wir euch als komplettes Catering oder als Streetfood-Konzept.",
      services_pizza_title: "Unsere Genusskarte",
      services_pizza_body: "Vorspeisen, handgemachte Pizzen und hausgemachte Desserts, sorgfältig komponiert für einen stimmigen Abend. Pizza steht im Mittelpunkt: lange Teigreifezeit, regionale und ausgewählte italienische Zutaten.",
      services_pizza_link: "Zu unserer Genusskarte",
      services_format_title: "Zwei Formate, ein Anspruch.",
      services_format_a_title: "Catering",
      services_format_a_body: "Für Hochzeiten, Firmenfeiern und private Anlässe. Beim Catering bevorzugen wir 30 cm-Sharing-Pizzen, ergänzt durch ausgewählte Vorspeisen und hausgemachte Desserts.",
      services_format_b_title: "Streetfood",
      services_format_b_body: "Auf Märkten, Festivals und Events, wir backen 22 cm-Pizzen direkt auf die Hand. Frisch aus dem Ofen, unkompliziert und mit Charakter.",
      services_setup_title: "Unser Setup",
      services_setup_body: "Wir bringen unseren Pizzaofen, Equipment und Service mit. Dazu stellen wir einen 4 × 6 m großen Pavillon auf, in dem wir unser komplettes Equipment aufbauen.",
      starters_eyebrow: "Vorspeisen",
      starters_lead: "Sorgfältig komponierte Vorspeisen, leicht und stimmig, der Auftakt zu eurem Abend.",
      desserts_eyebrow: "Desserts",
      desserts_lead: "Liebevoll zubereitete Desserts, die den Abend geschmackvoll abrunden.",
      see_genusskarte: "Zur Genusskarte",
      pricing_eyebrow: "Anfrage & Preisgestaltung",
      pricing_title: "Jede Feier ist einzigartig.",
      pricing_body: "Deshalb stellen wir unser Angebot individuell zusammen, nach Personenzahl, Speisenauswahl, Veranstaltungsort und gewünschtem Ablauf. Schreibt uns einfach an und wir erstellen euch ein unverbindliches Angebot.",
      pricing_points: [
        "Auch kleinere Feiern sind grundsätzlich möglich.",
        "Individuelle Beratung und Angebotserstellung.",
        "Preise richten sich nach Umfang, Personenzahl und Konzept.",
      ],
      pricing_cta: "Unverbindliches Angebot anfragen",
      concepts_eyebrow: "Unsere Catering-Konzepte",
      concepts_title: "Drei Konzepte, ein Anspruch.",
      concepts: [
        {
          name: "Rundum-Genuss",
          subtitle: "Vorspeise · Pizza · Dessert",
          body: "Ein harmonischer Genussabend vom ersten Gang bis zum süßen Abschluss. Ideal für Hochzeiten, Firmenfeiern und besondere Anlässe.",
          options_title: "Auch buchbar als:",
          options: ["Vorspeise & Pizza", "Pizza & Dessert"],
        },
        {
          name: "Pizza zum Teilen",
          subtitle: "Gemeinsam genießen",
          body: "Große, frisch gebackene Pizzen werden in Stücke geschnitten serviert und können gemeinsam genossen werden. Ein entspannter Ablauf mit viel Abwechslung und gemeinschaftlichem Genuss.",
        },
        {
          name: "Streetfood",
          subtitle: "Pizza auf die Hand",
          body: "Kleine Pizzen „auf die Hand\u201C, frisch gebacken und individuell belegt. Mediterranes Streetfood mit handgemachter Pizza als Mittelpunkt.",
        },
      ],
      occasions_title: "Wir begleiten unter anderem:",
      occasions: [
        "Hochzeiten",
        "Firmenfeiern",
        "Geburtstage",
        "Gartenfeste",
        "Sommerfeste",
        "Vereinsveranstaltungen",
        "Weihnachtsfeiern",
        "private Feiern",
      ],
      services_extras_title: "Catering, die ganze Tafel",
      services_extras_body: "Beim Catering ergänzen wir das Pizza-Angebot auf Wunsch durch ausgewählte Vorspeisen und hausgemachte Desserts, damit eure Tafel rund wird.",
      gallery_eyebrow: "Impressionen",
      gallery_title: "Augenblicke, die schmecken.",
      gallery_link: "Zur Galerie",
      cta_band_title: "Plant ihr ein besonderes Event?",
      cta_band_sub:
        "Erzählt uns von eurem Anlass, wir gestalten ein Genuss-Erlebnis, das eure Gäste lange im Herzen tragen.",
      cta_band_btn: "Unverbindlich anfragen",
    },
    about: {
      eyebrow: "Wer wir sind",
      title: "Die Menschen hinter Tæste.",
      lead: "Wir sind Annabell & Edgar.",
      sections: [
        {
          heading: "Wir sind Annabell & Edgar.",
          body: [
            "Was vor einigen Jahren mit den ersten selbst gebackenen Pizzen begann, entwickelte sich Schritt für Schritt zu einer gemeinsamen Leidenschaft. Aus dieser Begeisterung entstand schließlich Tæste.",
          ],
          image: "/annabell-edgar-stehend.webp?v=1",
          alt: "Annabell & Edgar Rücken an Rücken im Kiefernwald",
          objectPos: "center",
        },
        {
          heading: "Aus Leidenschaft entstand ein eigener Stil.",
          body: [
            "Aus unserer Begeisterung für Pizza hat sich mit der Zeit unser eigener Stil entwickelt. Mit viel Liebe zum Detail und echtem Handwerk machen wir jede Pizza zu etwas Besonderem.",
            "Für uns geht es um mehr als Pizza. Wir möchten einen bewussten Genuss schaffen, mit hochwertigen Zutaten, regionalen Produkten und einer Atmosphäre, in der Menschen gerne zusammenkommen.",
          ],
          image: "/eigener-stil.jpg",
          alt: "Handgemachte Pizza mit Mortadella, Stracciatella und Pistazienpesto",
          objectPos: "center",
          reverse: true,
        },
        {
          heading: "Wir begleiten eure Momente.",
          body: [
            "Heute begleiten wir Hochzeiten, Geburtstage, Firmenfeiern und Events mit handgemachter Pizza, ausgewählten Vorspeisen und hausgemachten Desserts.",
            "Unser Ziel ist es, Genuss, Qualität und Gastfreundschaft miteinander zu verbinden und Erinnerungen zu schaffen, die noch lange in guter Erinnerung bleiben.",
          ],
          image: "/gallery/g6.png",
          alt: "Unser abendliches Catering-Setup mit Pavillon, Lichterketten und Servierstationen",
          objectPos: "center",
          landscape: true,
        },
        {
          heading: "Bewusster Genuss.",
          body: [
            "Uns ist ein bewusster Umgang mit Lebensmitteln besonders wichtig. Deshalb möchten wir Schritt für Schritt einen Weg gehen, der Regionalität, hochwertige Zutaten und einen respektvollen Umgang mit Mensch, Tier und Umwelt miteinander verbindet.",
          ],
          image: "/bewusster-genuss.png",
          alt: "Hochwertige Zutaten aus der Region",
          objectPos: "center",
          reverse: true,
        },
        {
          heading: "Zusammen mit regionalen Partnern.",
          body: [
            "Aus diesem Grund möchten wir künftig verstärkt mit regionalen Produzenten und Partnern zusammenarbeiten, die diese Werte mit uns teilen.",
            "So möchten wir langfristig ein Catering schaffen, das geschmacklich überzeugt und gleichzeitig Verantwortung für Mensch, Tier und Umwelt übernimmt.",
          ],
          image: "/regionale-partner.png",
          alt: "Regionale Zusammenarbeit",
          objectPos: "center",
        },
        {
          heading: "Jede Veranstaltung ist einzigartig.",
          body: [
            "Ob Hochzeit, Geburtstag, Firmenfeier oder Event, wir gestalten unser Catering individuell und gehen auf eure Wünsche ein. So entsteht ein Konzept, das perfekt zu euch und eurem Anlass passt.",
          ],
          cta: { label: "Anfrage starten", href: "/kontakt" },
        },
      ],
      taeste_meaning: [
        ["Tæste", "Geschmack"],
        ["Tæste", "Genuss"],
        ["Tæste", "Gefühl"],
        ["Tæste", "bewusst erleben"],
        ["Tæste", "besondere Momente"],
      ],
      values_title: "Was uns trägt.",
      values: [
        ["Qualität", "Beste Zutaten, sorgfältig ausgewählt, Geschmack beginnt vor dem Ofen."],
        ["Handwerk", "Teig, der Zeit bekommt. Jede Pizza wird von Hand geformt."],
        ["Gastfreundschaft", "Wir empfangen euch wie Freunde, herzlich, aufmerksam, unkompliziert."],
        ["Leidenschaft", "Wir machen das aus Liebe. Das schmeckt man in jedem Bissen."],
      ],
    },
    weddings: {
      eyebrow: "Hochzeiten & besondere Anlässe",
      title: "Eure Liebe verdient besondere Geschmacksmomente.",
      body:
        "Wir gestalten ein mediterranes Catering-Erlebnis, das sich elegant in eure Hochzeit einfügt. Vom Aperitif unter alten Bäumen bis zur knusprigen Pizza aus dem Pizzaofen, wir kümmern uns um die Details, damit ihr den Tag genießen könnt.",
      includes_title: "Was wir mitbringen.",
      includes: [
        "Mobiler Pizzaofen & Pizza-Station",
        "Kuratierte Vorspeisen",
        "Hausgemachte Desserts",
        "Stilvolles Equipment in natürlichen Materialien",
        "Aufmerksamer Service mit Herz",
      ],
      cta: "Hochzeit anfragen",
    },
    catering: {
      eyebrow: "Unsere Genusskarte",
      title: "Vorspeisen. Pizzen. Desserts.",
      body:
        "Unsere Genusskarte ist auf einen entspannten Abend ausgelegt: liebevoll zubereitete Vorspeisen und frisch gebackene Pizzen werden parallel serviert. Zum süßen Abschluss reichen wir hausgemachte Desserts.",
      starters_title: "Vorspeisen",
      starters_body:
        "Sorgfältig komponierte Vorspeisen, leicht und stimmig, der Auftakt zu eurem Abend.",
      starters_items: [
        ["Italienischer Brotsalat", "Geröstetes Brot · Tomaten · Kräuter · hochwertiges Olivenöl"],
        ["Mediterraner Nudelsalat", "Hausgemachtes Pesto · sonnengereifte Tomaten · Parmesan · Oliven"],
        ["Antipasti-Platten", "Individuell zusammengestellt mit gegrilltem Gemüse, Mozzarella, Käse- und Wurstspezialitäten, je nach Veranstaltung."],
      ],
      starters_note: "Vorspeisen bieten wir im Rahmen unseres Caterings an.",
      pizzas_eyebrow: "Pizzen",
      pizzas_title: "Authentische Pizza, modern interpretiert.",
      desserts_title: "Desserts",
      desserts_body:
        "Liebevoll zubereitete Desserts, die den Abend geschmackvoll abrunden. Saisonal, ehrlich, mit Aufmerksamkeit fürs Detail.",
      desserts_items: [
        ["Klassisches Tiramisu", "Cremig, löffelzart, verführerisch, wie es sein muss."],
        ["Panna Cotta", "Seidig, leicht, mit fruchtiger Begleitung."],
        ["Dessertpizza", "Unsere süße Interpretation aus dem Pizzaofen."],
        ["Zitronenmousse in echter Zitronenschale", "Unser Hingucker, luftig, mediterran, serviert in der ausgehöhlten Zitrone."],
      ],
      desserts_highlight: "Zitronenmousse in echter Zitronenschale",
      desserts_highlight_note: "Unser besonderer Hingucker, fängt den mediterranen Charakter von Tæste in einem Bissen ein.",
      desserts_note: "Desserts bieten wir im Rahmen unseres Caterings an.",
      events_title: "Wir begleiten unter anderem:",
      events: [
        "Hochzeiten",
        "Geburtstage",
        "Firmenveranstaltungen",
        "Sommerfeste",
        "Märkte",
        "Festivals",
        "Private Feiern",
        "Individuelle Events",
      ],
      cta: "Catering anfragen",
    },
    philosophy: {
      eyebrow: "Unsere Philosophie",
      title: "Genuss, Qualität und Verantwortung passen wunderbar zusammen.",
      body:
        "Nachhaltigkeit bedeutet für uns nicht, perfekt zu sein, sondern bewusst zu handeln. Wir möchten Schritt für Schritt verantwortungsvoller arbeiten, hochwertige Zutaten bewusst auswählen und verstärkt mit regionalen Produzenten und Partnern zusammenarbeiten.",
      values: [
        ["Qualität", "Wir wählen Zutaten, hinter denen wir stehen."],
        ["Genuss", "Essen darf Zeit brauchen, und Freude machen."],
        ["Gemeinschaft", "Wir glauben an Tische, die Menschen zusammenbringen."],
        ["Gastfreundschaft", "Jeder Gast ist bei uns willkommen."],
        ["Nachhaltigkeit", "Bewusst und Schritt für Schritt."],
        ["Regionalität", "Partnerschaften mit regionalen Produzenten."],
        ["Handwerk", "Jede Pizza wird mit Hand und Herz gefertigt."],
        ["Leidenschaft", "Was uns antreibt, schmeckt man."],
      ],
    },
    gallery: {
      eyebrow: "Galerie",
      title: "Augenblicke aus unserer Welt.",
      body: "Eindrücke von Events, Hochzeiten und unserer Pizza aus dem Pizzaofen.",
    },
    reviews: {
      eyebrow: "Was unsere Gäste sagen",
      title: "Genuss, der in Erinnerung bleibt.",
      google_label: "Google Rezension",
      view_all: "Alle Bewertungen auf Google ansehen",
      write: "Tæste auf Google bewerten",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Erzählt uns von eurem Event.",
      body:
        "Wir freuen uns darauf, euer Anliegen kennenzulernen. Bitte teilt uns ein paar Eckdaten mit, wir melden uns persönlich bei euch zurück.",
      notice_eyebrow: "Anfragen für Veranstaltungen ab 2027",
      notice_body: [
        "Wir befinden uns aktuell in der Aufbauphase von Tæste und nehmen derzeit Anfragen für Veranstaltungen ab 2027 entgegen.",
        "Für Veranstaltungen im Jahr 2026 sind wir leider bereits ausgebucht bzw. nehmen keine weiteren Anfragen mehr an.",
        "Gerne lernen wir euch schon heute kennen, beantworten eure Fragen und planen gemeinsam eure Veranstaltung für 2027. So können wir jedem Event von Beginn an unsere volle Aufmerksamkeit schenken.",
      ],
      form: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon",
        event_type: "Art der Veranstaltung",
        event_type_ph: "Bitte wählen",
        event_date: "Datum (gewünscht)",
        guests: "Gästeanzahl (Erwachsene)",
        guests_ph: "z. B. 80",
        children: "Kinder (bis einschl. 12 Jahre)",
        children_ph: "z. B. 10",
        concept: "Gewünschtes Konzept",
        concept_ph: "Bitte wählen (optional)",
        location: "Ort / PLZ",
        message: "Nachricht",
        message_ph: "Erzählt uns kurz von eurem Vorhaben…",
        submit: "Anfrage senden",
        success: "Danke! Wir haben eure Anfrage erhalten und melden uns in Kürze.",
        error: "Etwas ist schiefgelaufen. Bitte versucht es erneut.",
        required: "Bitte ausfüllen",
        event_types: [
          "Hochzeit",
          "Geburtstag",
          "Firmenevent",
          "Sommerfest",
          "Markt / Festival",
          "Private Feier",
          "Sonstiges",
        ],
        concepts: [
          "Rundum-Genuss (Vorspeise · Pizza · Dessert)",
          "Vorspeise & Pizza",
          "Pizza & Dessert",
          "Pizza zum Teilen",
          "Streetfood",
          "Noch unentschlossen",
        ],
      },
      info_title: "Direkt erreichen.",
      info: {
        email: "info@taeste.de",
        phone: "+49 1512 9402613",
        web: "taeste.de",
        ig: "@taeste.catering_streetfood",
        location: "02999 Lohsa · Lausitz",
      },
      location_title: "Unser Standort",
      location_lead: "Wir sind in der Lausitz zu Hause, in der Nähe von Hoyerswerda. Von hier aus begleiten wir Events in Sachsen, Brandenburg und darüber hinaus.",
    },
    footer: {
      tagline: "Pizza · Catering · Streetfood",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
      admin: "Admin",
    },
    admin: {
      login_title: "Admin-Bereich",
      login_sub: "Bitte mit Admin-Zugang anmelden.",
      email: "E-Mail",
      password: "Passwort",
      submit: "Anmelden",
      logout: "Abmelden",
      dashboard_title: "Anfragen",
      empty: "Noch keine Anfragen vorhanden.",
      status: { neu: "Neu", in_bearbeitung: "In Bearbeitung", abgeschlossen: "Abgeschlossen" },
      delete: "Löschen",
      created: "Eingegangen",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Offering",
      gallery: "Gallery",
      contact: "Contact",
      cta: "Send inquiry",
    },
    home: {
      eyebrow: "Pizza · Catering · Streetfood",
      hero_slogan: "„Taste the Moment\u201C",
      hero_title_a: "Flavour that",
      hero_title_b: "brings people together.",
      hero_sub:
        "Inspiriert von italienischer Pizzakultur, gemacht für moderne Events. Hochwertige Pizza, klare Konzepte, stilvolles Catering.",
      cta_primary: "Send an inquiry",
      cta_secondary: "Our offering",
      intro_eyebrow: "Who we are",
      intro_title: "The people behind Tæste.",
      intro_body:
        "For us, indulgence means taking time together, creating special moments and pairing great food with atmosphere, quality and emotion. We don’t just serve dishes, we craft experiences.",
      intro_link: "Meet Annabell & Edgar",
      services_eyebrow: "Our offering",
      services_title: "Pizza at the centre.",
      services_lead: "We mainly make pizza, handmade, with long-fermented dough and carefully chosen ingredients. On request we accompany you as a full catering or as a streetfood concept.",
      services_pizza_title: "Our menu",
      services_pizza_body: "Starters, handmade pizzas and homemade desserts, carefully composed for a harmonious evening. Pizza takes centre stage: long-fermented dough, regional and selected Italian ingredients.",
      services_pizza_link: "See our menu",
      services_format_title: "Two formats, one standard.",
      services_format_a_title: "Catering",
      services_format_a_body: "For weddings, corporate events and private occasions. For catering we prefer 30 cm sharing pizzas, complemented by selected starters and homemade desserts.",
      services_format_b_title: "Streetfood",
      services_format_b_body: "At markets, festivals and events, we bake 22 cm pizzas straight to the hand. Fresh out of the oven, unfussy, with character.",
      services_setup_title: "Our setup",
      services_setup_body: "We bring our pizza oven, equipment and service. We also set up a 4 × 6 m pavilion that holds our full equipment.",
      starters_eyebrow: "Starters",
      starters_lead: "Carefully composed starters, light and harmonious, the opening of your evening.",
      desserts_eyebrow: "Desserts",
      desserts_lead: "Lovingly prepared desserts that round off the evening beautifully.",
      see_genusskarte: "View the menu",
      pricing_eyebrow: "Inquiry & pricing",
      pricing_title: "Every celebration is unique.",
      pricing_body: "We tailor every offer individually, based on guest count, food selection, venue and the flow of the day. Just get in touch and we’ll prepare a non-binding offer for you.",
      pricing_points: [
        "Smaller celebrations are generally possible.",
        "Personal consultation and tailored offers.",
        "Pricing depends on scope, guest count and concept.",
      ],
      pricing_cta: "Request a non-binding offer",
      concepts_eyebrow: "Our catering concepts",
      concepts_title: "Three concepts, one standard.",
      concepts: [
        {
          name: "Rundum-Genuss",
          subtitle: "Starter · Pizza · Dessert",
          body: "A harmonious evening of indulgence, from the first course to a sweet finish. Perfect for weddings, corporate events and special occasions.",
          options_title: "Also bookable as:",
          options: ["Starter & pizza", "Pizza & dessert"],
        },
        {
          name: "Pizza zum Teilen",
          subtitle: "Shared enjoyment",
          body: "Large, freshly baked pizzas served in slices to share. A relaxed flow, plenty of variety and a real sense of togetherness.",
        },
        {
          name: "Streetfood",
          subtitle: "Pizza on the hand",
          body: "Small pizzas straight to the hand, freshly baked and individually topped. Mediterranean streetfood with handmade pizza at its heart.",
        },
      ],
      occasions_title: "We accompany, among others:",
      occasions: [
        "Weddings",
        "Corporate events",
        "Birthdays",
        "Garden parties",
        "Summer festivals",
        "Club events",
        "Christmas parties",
        "Private celebrations",
      ],
      services_extras_title: "Catering, the whole table",
      services_extras_body: "For catering we complement the pizza on request with selected starters and homemade desserts to round off your table.",
      gallery_eyebrow: "Impressions",
      gallery_title: "Moments you can taste.",
      gallery_link: "View gallery",
      cta_band_title: "Planning something special?",
      cta_band_sub:
        "Tell us about the occasion, we’ll craft an experience your guests will carry in their hearts.",
      cta_band_btn: "Get in touch",
    },
    about: {
      eyebrow: "Who we are",
      title: "The people behind Tæste.",
      lead: "We are Annabell & Edgar.",
      sections: [
        {
          heading: "We are Annabell & Edgar.",
          body: [
            "What began a few years ago with our first home-baked pizzas grew step by step into a shared passion. From this enthusiasm, Tæste was born.",
          ],
          image: "/annabell-edgar-stehend.webp?v=1",
          alt: "Annabell & Edgar back to back in a pine forest",
          objectPos: "center",
        },
        {
          heading: "From passion to our own style.",
          body: [
            "Our enthusiasm for pizza has, over time, grown into a style of our own. With attention to detail and true craft, we make every pizza something special.",
            "For us it's about more than pizza. We want to create mindful enjoyment, with quality ingredients, regional products and an atmosphere that brings people together.",
          ],
          image: "/eigener-stil.jpg",
          alt: "Handmade pizza with mortadella, stracciatella and pistachio pesto",
          objectPos: "center",
          reverse: true,
        },
        {
          heading: "We accompany your moments.",
          body: [
            "Today we cater weddings, birthdays, corporate events and celebrations with handmade pizza, curated starters and homemade desserts.",
            "Our goal is to bring together indulgence, quality and hospitality, creating memories that stay with you long afterwards.",
          ],
          image: "/gallery/g6.png",
          alt: "Our evening catering setup with pavilion, string lights and serving stations",
          objectPos: "center",
          landscape: true,
        },
        {
          heading: "Mindful enjoyment.",
          body: [
            "A conscious approach to food is especially important to us. Step by step we're building a path that connects regionality, quality ingredients and respect for people, animals and the environment.",
          ],
          image: "/bewusster-genuss.png",
          alt: "Quality regional ingredients",
          objectPos: "center",
          reverse: true,
        },
        {
          heading: "Together with regional partners.",
          body: [
            "That's why we want to work increasingly with regional producers and partners who share these values.",
            "Long term, we aim to create catering that delivers on flavour and takes responsibility for people, animals and the environment.",
          ],
          image: "IMAGES.hero",
          alt: "Regional collaboration",
        },
        {
          heading: "Every event is unique.",
          body: [
            "Wedding, birthday, corporate or private, we shape our catering individually and respond to your wishes. The result is a concept that fits you and your occasion perfectly.",
          ],
          cta: { label: "Start an inquiry", href: "/kontakt" },
        },
      ],
      taeste_meaning: [
        ["Tæste", "Taste"],
        ["Tæste", "Indulgence"],
        ["Tæste", "Feeling"],
        ["Tæste", "Conscious experience"],
        ["Tæste", "Special moments"],
      ],
      values_title: "What carries us.",
      values: [
        ["Quality", "Carefully chosen ingredients, flavour begins before the oven."],
        ["Craft", "Dough that gets time. Every pizza shaped by hand."],
        ["Hospitality", "We welcome you like friends, warm, attentive, easy."],
        ["Passion", "We do this out of love. You can taste it."],
      ],
    },
    weddings: {
      eyebrow: "Weddings & special occasions",
      title: "Your love deserves remarkable flavour.",
      body:
        "We design a Mediterranean catering experience that fits elegantly into your wedding. From aperitifs under old trees to crispy pizza from our pizza oven, we take care of the details so you can enjoy the day.",
      includes_title: "What we bring.",
      includes: [
        "Mobile pizza oven & pizza station",
        "Curated starters",
        "Homemade desserts",
        "Stylish equipment in natural materials",
        "Attentive service with heart",
      ],
      cta: "Inquire for your wedding",
    },
    catering: {
      eyebrow: "Our menu",
      title: "Starters. Pizzas. Desserts.",
      body:
        "Our menu is designed for a relaxed evening: lovingly prepared starters and freshly baked pizzas are served in parallel. To finish, we serve homemade desserts.",
      starters_title: "Starters",
      starters_body:
        "Carefully composed starters, light and harmonious, the opening of your evening.",
      starters_items: [
        ["Italian bread salad", "Toasted bread · tomatoes · herbs · quality olive oil"],
        ["Mediterranean pasta salad", "Homemade pesto · sun-ripened tomatoes · parmesan · olives"],
        ["Antipasti platters", "Individually composed with grilled vegetables, mozzarella, cheese and cured-meat specialties, depending on the event."],
      ],
      starters_note: "Starters are offered as part of our catering.",
      pizzas_eyebrow: "Pizzas",
      pizzas_title: "Authentic pizza, modern interpretations.",
      desserts_title: "Desserts",
      desserts_body:
        "Lovingly prepared desserts that round off the evening. Seasonal, honest, with attention to detail.",
      desserts_items: [
        ["Classic Tiramisu", "Creamy, spoon-tender, seductive, as it must be."],
        ["Panna Cotta", "Silky, light, with a fruity companion."],
        ["Dessert pizza", "Our sweet interpretation from the pizza oven."],
        ["Lemon mousse in a real lemon shell", "Our showstopper, airy, Mediterranean, served inside the hollowed lemon."],
      ],
      desserts_highlight: "Lemon mousse in a real lemon shell",
      desserts_highlight_note: "Our signature highlight, captures the Mediterranean character of Tæste in a single bite.",
      desserts_note: "Desserts are offered as part of our catering.",
      events_title: "We cater for:",
      events: [
        "Weddings",
        "Birthdays",
        "Corporate events",
        "Summer parties",
        "Markets",
        "Festivals",
        "Private celebrations",
        "Bespoke events",
      ],
      cta: "Inquire about catering",
    },
    philosophy: {
      eyebrow: "Our philosophy",
      title: "Indulgence, quality and responsibility belong together.",
      body:
        "Sustainability, for us, isn’t about being perfect, it’s about acting consciously. Step by step we work more responsibly, choose quality ingredients and partner with regional producers.",
      values: [
        ["Quality", "Ingredients we stand behind."],
        ["Indulgence", "Food may take time, and bring joy."],
        ["Community", "We believe in tables that bring people together."],
        ["Hospitality", "Every guest is welcome."],
        ["Sustainability", "Step by step, consciously."],
        ["Regionality", "Partnerships with regional producers."],
        ["Craft", "Every pizza made by hand and heart."],
        ["Passion", "What drives us, you can taste it."],
      ],
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Glimpses of our world.",
      body: "Impressions of events, weddings and our pizza from the pizza oven.",
    },
    reviews: {
      eyebrow: "What our guests say",
      title: "Enjoyment that lingers.",
      google_label: "Google Review",
      view_all: "See all reviews on Google",
      write: "Rate Tæste on Google",
    },
    contact: {
      eyebrow: "Contact",
      title: "Tell us about your event.",
      body:
        "We’d love to hear about your occasion. Share a few details and we’ll get back to you personally.",
      notice_eyebrow: "Now booking events from 2027",
      notice_body: [
        "We're currently in the launch phase of Tæste and are taking inquiries for events from 2027.",
        "Unfortunately, we're fully booked for 2026 and can no longer accept inquiries for that year.",
        "We'd love to get to know you today, answer your questions and plan your 2027 event together, so we can give every event our full attention from the very beginning.",
      ],
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        event_type: "Type of event",
        event_type_ph: "Please select",
        event_date: "Preferred date",
        guests: "Number of guests (adults)",
        guests_ph: "e.g. 80",
        children: "Children (up to age 12)",
        children_ph: "e.g. 10",
        concept: "Preferred concept",
        concept_ph: "Please select (optional)",
        location: "Location / ZIP",
        message: "Message",
        message_ph: "Tell us briefly about your plans…",
        submit: "Send inquiry",
        success: "Thank you! We’ve received your inquiry and will be in touch shortly.",
        error: "Something went wrong. Please try again.",
        required: "Please fill in",
        event_types: ["Wedding", "Birthday", "Corporate", "Summer party", "Market / Festival", "Private", "Other"],
        concepts: [
          "Full menu (starter · pizza · dessert)",
          "Starter & pizza",
          "Pizza & dessert",
          "Pizza to share",
          "Streetfood",
          "Still undecided",
        ],
      },
      info_title: "Reach us directly.",
      info: {
        email: "info@taeste.de",
        phone: "+49 1512 9402613",
        web: "taeste.de",
        ig: "@taeste.catering_streetfood",
        location: "02999 Lohsa · Lausitz",
      },
      location_title: "Where we are",
      location_lead: "We're based in Lausitz, near Hoyerswerda. From here we cater events across Saxony, Brandenburg and beyond.",
    },
    footer: {
      tagline: "Pizza · Catering · Streetfood",
      rights: "All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy",
      admin: "Admin",
    },
    admin: {
      login_title: "Admin area",
      login_sub: "Please sign in with admin credentials.",
      email: "Email",
      password: "Password",
      submit: "Sign in",
      logout: "Sign out",
      dashboard_title: "Inquiries",
      empty: "No inquiries yet.",
      status: { neu: "New", in_bearbeitung: "In progress", abgeschlossen: "Done" },
      delete: "Delete",
      created: "Received",
    },
  },
};

export const useT = (lang) => translations[lang] || translations.de;
